export const ModalLogOutTranslationsEn = {
  LogOut: 'Do you really want to log out?',
  yes: 'Yes, log out',
  back: 'Back',
};
